<template>
  <header v-if="isMobile">
      <div class="mtop" >
        <el-row >
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="3"><router-link  to="/home" ><img class="vam" src="../assets/logo.png" width="80%" /></router-link></el-col>
          <el-col :span="15">游戏代练师技能认定平台</el-col>
          <!-- <el-col :span="2" >
              <template v-if="isShow">
                  <img @click="isShowDialog = !isShowDialog" class="vam" src="../assets/icon.png" width="70%" />
                  <div class="dialog-userinfo" v-if="isShowDialog">
                    <p @click="isShowDialog = !isShowDialog"><router-link  to="/my-sign-up" >报名信息</router-link></p>
                    <p @click="isShowDialog = !isShowDialog"><router-link  to="/login" >退出账号</router-link></p>
                  </div>
               </template>
          </el-col> -->
          <el-col :span="5">
          <!--  <template v-if="isShow">
            <img @click="drawer = !drawer" class="vam" src="../assets/icon4.png" width="70%" />
            </template> -->
            <a class="mchatQQ" href="mqqwpa://im/chat?chat_type=wpa&uin=3001238329&version=1&src_type=web&web_src=http:://wpa.b.qq.com" target="_blank"><img class="vam" src="../assets/qq.png" width="30%" /> 客服</a>
          </el-col>

        </el-row>
      </div>

     <!-- <div class="transition-box-bg" v-if="drawer" @click="drawer = !drawer"></div>
      <div :class="drawer?'transition-box transition-box-right':'transition-box'" >
          <ul>
            <li @click="drawer = !drawer"><router-link  to="/sign-up" >在线报名</router-link><i class="el-icon-arrow-right gray"></i></li>
            <li @click="drawer = !drawer"><router-link  to="/exam-result" >理论考试</router-link><i class="el-icon-arrow-right gray"></i></li>
            <li @click="drawer = !drawer"><router-link  to="/operation" >实操考试</router-link><i class="el-icon-arrow-right gray"></i></li>
          </ul>
      </div> -->



  </header>
    <header v-else>
       <div class="top">
            <div class="content">
                <div class="header">
                    <dl>
                      <dt><router-link class="header_logo" to="/home" ><img class="vam" src="../assets/logo.png" width="90"></router-link></dt>
                      <dd>
                          <div>
                          <span class="header_title">游戏代练师技能认定平台</span>
                          <div class="header_user">
                               <template v-if="isShow">
                                  <span><i class="icon3 icon3-user"></i>{{nickName}}</span>
                                  <div class="header_user_nav">
                                    <ul>
                                        <li><router-link  to="/auth" >我的实名认证</router-link></li>
                                        <li><router-link  to="/my-sign-up" >我的报名信息</router-link></li>
                                        <li><a href="http://cert.chinaesa.org.cn/public/index.php" target="_blank">我的证书</a></li>
                                        <!-- <li><a href="javascript:void(0)" @click="exitSearch">我的证书</a></li> -->

                                        <!-- <li><a href="javascript:void(0)" @click="exit">退出账号</a></li> -->
                                        <li><router-link  to="/login" >退出账号</router-link></li>
                                    </ul>
                                  </div>
                               </template>
  			                       <template v-else><router-link class="header_login" to="/login" >登录/注册</router-link> </template>
                          </div>
                          </div>

                          <div class="header_nav">
                          <ul>
                              <li ><router-link  to="/home"  active-class="hover" >首页</router-link></li>
                              <li>
                                  <a href="javascript:void(0)">业务办理<em></em></a>
                                  <div class="header_nav_child">
                                      <router-link  to="/sign-up" >在线报名</router-link>
                                      <router-link  to="/exam-result" >理论考试</router-link>
                                      <router-link  to="/operation" >实操考试</router-link>
                                      <router-link  to="/address" >证书办理</router-link>
                                  </div>
                              </li>
                              <li><router-link  to="/exam-search" active-class="hover">成绩查询</router-link></li>
                              <li><a href="http://www.chinagungho.org/cx/index.php?m=&c=certificate&a=index" target="_blank">证书查询</a></li>
                              <li><router-link to="/information" active-class="hover">资讯</router-link></li>
                              <li><router-link to="/notice" active-class="hover">公示公告</router-link></li>
                          </ul>
                          </div>
                      </dd>
                    </dl>
                </div>
            </div>
        </div>
        <div class="top_spacing"></div>

        <div class="chatQQ">
          <div class="chatQQ_1"><a href="http://wpa.qq.com/msgrd?v=3&uin=3001238329&site=在线客服&menu=yes" target="_blank"><img src="../assets/qq.png" width="100%" />在<br />线<br />客<br />服</a></div>
        </div>
    </header>
</template>

<script>
export default {
  name: 'topHeader',
  data () {
    return {
       show: false,
       Bal:0,
       isShowRechargeWindow:false,
       drawer:true,
       isShowDialog:false
    }
  },
  computed:{
     isShow(){
       return this.$store.getters.isShow;
     },
     nickName(){
       return this.$store.getters.nickName;
     },
     isMobile(){
       return this.common.isMobile();
     }
  },
  mounted(){
    //alert(this.$route.path);
  },
  methods: {
    exit(){
      this.common.ClearlocalStorage("UnLockUserData");
      //this.reload();
      this.$store.dispatch('hideActions');
      this.$router.go(0);
    },
    enter(){
      this.show=true;
    },
    leave(){
      this.show=false;
    },
    showRechargeWindow(){
				this.isShowRechargeWindow=true;
    },
    closeRechargeWindow(val){
				this.isShowRechargeWindow=val;
    },
    exitSearch(){
      const self=this;
			self.$alert('证书查询系统正在维护升级中，暂时无法查询', '', {
				confirmButtonText: '确定',
				type:"info",
				showClose:false,
				callback: action => {
					//self.$router.push({path:'/home'});
				}
			});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .transition-box{z-index:99; position: fixed; width:50%; height:100%; right:-300px; background: #fff; color:#000; font-size:1.2rem; vertical-align:middle; transition: right 0.5s linear 0.1s;}
  .transition-box-right{right:0; }
  .transition-box ul{ padding:2rem 5% 0;}
  .transition-box li{ padding:1rem 0; }
  .transition-box .gray{color:#999; float:right; font-size:1.4rem;}

  .transition-box-bg{position:fixed;width:100%;height:100%;bottom:0;background:#000;filter:alpha(opacity=50); -moz-opacity:0.5; opacity: 0.5; margin:0; padding:0; z-index:9; }


  .dialog-userinfo{ position: absolute;  padding:0 2rem; right:10%;background:#000;filter:alpha(opacity=90); -moz-opacity:0.9; opacity: 0.9; border-radius:0.8rem;}
  .dialog-userinfo a{color:#fff; font-weight: normal;}


</style>



// WEBPACK FOOTER //
// src/components/header.vue